import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { EVENTS as EVENT_MEDIA, mediaPath } from "@/lib/media";
const FeaturedEvent = () => {
  const $ = _c(18);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-3 sm:gap-4 mb-8 sm:mb-12 md:mb-16"><div className="w-4 h-4 rounded-full border border-[#DF6D2A] flex items-center justify-center"><span className="w-1.5 h-1.5 bg-[#DF6D2A] rounded-full animate-pulse" /></div><span className="font-body text-[12px] tracking-[0.25em] uppercase text-[#DF6D2A] font-semibold">Featured Upcoming Event</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      x: -30
    };
    t2 = {
      opacity: 1,
      x: 0
    };
    t3 = {
      once: true
    };
    t4 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute -inset-3 sm:-inset-4 border border-[#0F1C2E]/10 -z-10 translate-x-3 translate-y-3 sm:translate-x-4 sm:translate-y-4" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <img src={mediaPath(EVENT_MEDIA.placeholder)} alt={`${EVENT_MEDIA.placeholderAlt}, Global Diaspora Conference`} className="w-full h-full object-cover grayscale-[30%] sepia-[10%] group-hover:scale-105 transition-transform duration-1000 ease-out" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="w-full lg:w-[45%] relative">{t5}<div className="aspect-[16/9] sm:aspect-[3/4] lg:aspect-[4/5] overflow-hidden bg-[#0F1C2E] relative group">{t6}<div className="absolute top-4 right-4 sm:top-6 sm:right-6 bg-[#F4EFE6] border border-[#0F1C2E]/20 px-3 sm:px-4 py-1.5 sm:py-2 shadow-xl flex items-center gap-2 sm:gap-3 transform rotate-2"><span className="font-body text-[9px] sm:text-[10px] tracking-widest uppercase text-[#0F1C2E]">Ticket No.</span><span className="font-display text-[16px] sm:text-[20px] text-[#DF6D2A] font-bold">001</span></div></div></motion.div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      opacity: 0,
      y: 30
    };
    t9 = {
      opacity: 1,
      y: 0
    };
    t10 = {
      once: true
    };
    t11 = {
      duration: 0.8,
      delay: 0.2,
      ease: "easeOut"
    };
    $[8] = t10;
    $[9] = t11;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[8];
    t11 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="font-display text-[20px] sm:text-[24px] text-[#C9A84C] italic mb-3 sm:mb-4">October 14-16, 2026</p>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <br />;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <h2 className="font-display text-[34px] sm:text-[48px] md:text-[56px] lg:text-[72px] xl:text-[84px] leading-[0.9] text-[#0F1C2E] mb-5 sm:mb-6 md:mb-8 uppercase tracking-tight">Global {t13}Diaspora <br /><span className="text-[#DF6D2A]">Conference</span></h2>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  let t16;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="flex flex-wrap gap-5 sm:gap-6 md:gap-8 mb-6 sm:mb-8 md:mb-10 pb-6 sm:pb-8 md:pb-10 border-b border-[#0F1C2E]/10"><div><p className="font-body text-[10px] uppercase tracking-[0.2em] text-[#4C596B] mb-1">Location</p><p className="font-body text-[15px] sm:text-[18px] text-[#0F1C2E]">Suva, Fiji</p></div><div><p className="font-body text-[10px] uppercase tracking-[0.2em] text-[#4C596B] mb-1">Venue</p><p className="font-body text-[18px] text-[#0F1C2E]">Grand Pacific Hotel</p></div><div><p className="font-body text-[10px] uppercase tracking-[0.2em] text-[#4C596B] mb-1">Type</p><p className="font-body text-[18px] text-[#0F1C2E]">International Symposium</p></div></div>;
    t16 = <p className="font-body text-[14px] sm:text-[16px] md:text-[17px] text-[#4C596B] leading-[1.7] sm:leading-[1.8] font-light mb-8 sm:mb-10 md:mb-12 max-w-[600px]">A historic three-day symposium gathering descendants, historians, and policymakers from across the 15 Girmitiya nations. Engage in panel discussions, explore newly uncovered archival manifests, and celebrate the resilience of our shared ancestors.</p>;
    $[15] = t15;
    $[16] = t16;
  } else {
    t15 = $[15];
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <section className="bg-[#F4EFE6] py-16 sm:py-24 md:py-32 relative overflow-hidden"><div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12">{t0}<div className="flex flex-col lg:flex-row gap-10 sm:gap-12 lg:gap-24 items-center">{t7}<motion.div initial={t8} whileInView={t9} viewport={t10} transition={t11} className="w-full lg:w-[55%] flex flex-col">{t12}{t14}{t15}{t16}<div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-6"><button className="font-body px-6 sm:px-8 py-3.5 sm:py-4 btn-primary text-[12px] sm:text-[13px] tracking-[0.12em] sm:tracking-[0.15em] uppercase hover:bg-[#0F1C2E] transition-colors duration-300 text-center">Register Now</button><button className="font-body px-6 sm:px-8 py-3.5 sm:py-4 border border-[#0F1C2E]/20 text-[#0F1C2E] text-[12px] sm:text-[13px] tracking-[0.12em] sm:tracking-[0.15em] uppercase hover:bg-[#0F1C2E]/5 transition-colors duration-300 text-center">View Schedule</button></div></motion.div></div></div></section>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  return t17;
};
export default FeaturedEvent;